// Returns error message item if the passed string is empty.
export const requiredValidator = (value: string): string =>
    value
        ? ""
        : JSON.stringify({
              id: "RequiredFieldValidationMessage",
              defaultMessage: "This field is required",
          })
